import { inject } from 'vue';

export const UiToastSymbol = 'ungabunga'; // Symbol();

export function useToast () {
  const UiToast = inject(UiToastSymbol);
  if (!UiToast) {
    throw new Error ('No UI Toast provided!');
  }
  return UiToast;
}
